import api from './api';
import { Sale } from '../DataTransferObjects/Dtos';

export function criarVenda(data: Sale) {
  return api.post(`venda/venda-simplificada`, data);
} 
